import React from 'react';
import { Tooltip, tooltipClasses } from '@mui/material';
import { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip/Tooltip';

const AMBGTooltip = ({ children, ...props }: MuiTooltipProps): React.JSX.Element => (
	<Tooltip
		data-testid='tooltip'
		PopperProps={{
			modifiers: [
				{
					name: 'offset',
					options: {
						offset: [0, -10]
					}
				}
			],
			sx: {
				[`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
					marginTop: '0px'
				},
				[`&.${tooltipClasses.popper}[data-popper-placement*="bottom"]`]: {
					inset: '18px auto auto 0px !important'
				}
			}
		}}
		{...props}
	>
		{children}
	</Tooltip>
);

export default AMBGTooltip;
